import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-detail-email-link',
    templateUrl: './detail-email-link.component.html',
    styleUrls: ['./detail-email-link.component.scss'],
    standalone: true,
})
export class DetailEmailLinkComponent {
    public title = input<string>();
    public linkLabel = input<string>();
    public email = input.required<string>();
    public ariaLabel = input<string>();
    public outlined = input<boolean>(false);
}
